import { useState } from "react";
import { ILoginButtonProps } from "./types";
import LoginModal from "../../../Modals/LoginModal";

const LoginButton = ({ className = "", children, ...props }: ILoginButtonProps) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setShow(true)}
        className={`btn fw-semibold ${className}`}
        {...props} // ← passa todas as props nativas do botão
      >
        {children}
      </button>
      <LoginModal show={show} onHide={() => setShow(false)} />
    </>
  );
};

export default LoginButton;
